<app-dialog
  [title]="
    data.shipmentHeaderId === '' ? 'Add to Existing Draft' : 'Merge Shipment'
  "
  [actions]="[
    {
      text:  'Cancel',
      buttonStyle: 'underline'
    },
    {
      text: 'Confirm',
      isDisabled: loading || (!selectedShipment && !selectedShipmentPlan),
      spin: loading
    }
  ]"
  (action)="action($event)"
  (close)="close()"
>
  <mat-dialog-content>
    <div class="add-sku">
      <div class="add-sku_tabs">
        <div
          class="add-sku_tab"
          [ngClass]="{
            'shipment-list_tab--selected': selectedTab === 'All'
          }"
          *ngIf="!response?.isAddToDraftShipment"
        >
          <app-button
            [buttonSize]="'action'"
            [buttonStyle]="selectedTab === 'All' ? 'selected' : 'wire'"
            [buttonColor]="'primary'"
            (click)="selectedTab = 'All'"
            >All</app-button
          >
        </div>
        <div
          class="add-sku_tab"
          [ngClass]="{
            'shipment-list_tab--selected': selectedTab === 'working'
          }"
          *ngIf="!response?.isAddToDraftShipment"
        >
          <app-button
            [buttonSize]="'action'"
            [buttonStyle]="selectedTab === 'working' ? 'selected' : 'wire'"
            [buttonColor]="'primary'"
            (click)="selectedTab = 'working'"
            >Working</app-button
          >
        </div>
        <div
          class="add-sku_tab"
          [ngClass]="{
            'shipment-list_tab--selected': selectedTab === 'shipment plans'
          }"
          *ngIf="!response?.isAddToDraftShipment"
        >
          <app-button
            [buttonSize]="'action'"
            [buttonStyle]="
              selectedTab === 'shipment plans' ? 'selected' : 'wire'
            "
            [buttonColor]="'primary'"
            (click)="selectedTab = 'shipment plans'"
            >Shipment Plan</app-button
          >
        </div>
        <div
          class="add-sku_tab"
          [ngClass]="{
            'shipment-list_tab--selected': selectedTab === 'draft'
          }"
        >
          <app-button
            [buttonSize]="'action'"
            [buttonStyle]="selectedTab === 'draft' ? 'selected' : 'wire'"
            [buttonColor]="'primary'"
            (click)="selectedTab = 'draft'"
            >Drafts</app-button
          >
        </div>
      </div>
      <div class="shipment-list thin-scrollbars" cdkScrollable>
        <ng-template
          [ngIf]="selectedTab === 'working' || selectedTab === 'All'"
        >
          <span *ngIf="shipments.length; else elseBlock">
            <div *ngFor="let item of shipmentsNew | keyvalue">
              <div *ngIf="item.key === 'WORKING'; else elseBlock">
                <ng-container
                  *ngTemplateOutlet="inner; context: { shipmentList: item }"
                ></ng-container>
              </div>
            </div>
          </span>
          <ng-template #elseBlock>
            <div
              *ngIf="
                shipments.length == 0 || !shipmentsNew.hasOwnProperty('WORKING')
              "
            >
              <div class="shipment-list_title" *ngIf="selectedTab === 'All'">
                WORKING
              </div>
              <div class="shipment-list_error">
                <span>No Working Shipments Available</span>
              </div>
            </div>
          </ng-template>
        </ng-template>

        <ng-template
          [ngIf]="selectedTab === 'shipment plans' || selectedTab === 'All'"
        >
          <div
            class="shipment-list_title"
            *ngIf="shipmentPlans && selectedTab === 'All'"
          >
            SHIPMENT PLANS
          </div>
          <div
            class="shipment-list_item"
            [ngClass]="{
              'shipment-list_item--selected':
                plan.shipmentPlanHeaderId === selectedShipmentPlan
            }"
            (click)="selectShipmentPlan(plan.shipmentPlanHeaderId, i)"
            *ngFor="let plan of shipmentPlans; let i = index"
          >
            <div class="shipment-list_checkbox">
              <i class="fas fa-check-circle"></i>
            </div>
            <app-shipment-plan-item [plan]="plan"></app-shipment-plan-item>
          </div>
          <div *ngIf="shipmentPlans && !shipmentPlans.length">
            <!--  <app-button (click)="planShipment()" [buttonSize]="'small'"
              >Plan Shipment</app-button
            >-->
            <div class="shipment-list_error">
              <span>No Plans Available</span>
            </div>
          </div>
        </ng-template>

        <div *ngIf="selectedTab === 'draft' || selectedTab === 'All'">
          <span *ngIf="shipments.length; else elseDraftBlock">
            <div *ngFor="let item of shipmentsNew | keyvalue">
              <div *ngIf="item.key === 'DRAFT'; else elseDraftBlock">
                <ng-container
                  *ngTemplateOutlet="inner; context: { shipmentList: item }"
                ></ng-container>
              </div>
            </div>
          </span>
          <ng-template #elseDraftBlock>
            <div
              *ngIf="
                shipments.length == 0 || !shipmentsNew.hasOwnProperty('DRAFT')
              "
            >
              <div class="shipment-list_title" *ngIf="selectedTab === 'All'">
                DRAFTS
              </div>
              <div class="shipment-list_error">
                <span>No Drafts Available</span>
              </div>
            </div>
            <!--<div *ngIf="selectedTab === 'draft'">
              <app-button (click)="createDraft()" [buttonSize]="'small'"
                >Save as New Draft</app-button
              >
            </div>-->
          </ng-template>
        </div>

        <ng-template #inner let-data="shipmentList">
          <div class="shipment-list_title" *ngIf="selectedTab === 'All'">
            {{ data.key }}
          </div>
          <div
            class="shipment-list_item"
            (click)="selectShipment(shipment)"
            [ngClass]="{
              'shipment-list_item--selected':
                shipment.shipmentHeaderId === selectedShipment
            }"
            *ngFor="let shipment of data.value"
          >
            <div class="shipment-list_checkbox">
              <i class="fas fa-check-circle"></i>
            </div>
            <div class="shipment-list_item-title">
              <div class="shipment-list_item-name">
                {{
                  shipment.amazonShipmentId
                    ? shipment.amazonShipmentId
                    : "Draft " + shipment.shipmentHeaderId
                }}
              </div>
                {{shipment.shipmentName}}
            </div>
            <div class="shipment-list_item-meta">
              <b>Prep by: </b> {{shipment.isPrepByAmazon ? 'Amazon' : 'Seller'}}
            </div>
            <div class="shipment-list_item-meta">
              <b>SKUs: </b> {{ shipment.totalSkus }}
            </div>
            <div class="shipment-list_item-meta">
              <b>QTY: </b> {{ shipment.totalQty }}
            </div>
            <div class="shipment-list_item-meta">
              <div class="shipment-list_type">
                {{ shipment.shipmentType }}
              </div>
            </div>
            <div class="shipment-list_item-meta">
              <div class="shipment-list_warehouse">
                <div
                  [matTooltip]="
                    shipment.sourceWarehouse?.addressLine1 +
                    ' ' +
                    shipment.sourceWarehouse?.city +
                    ' ' +
                    shipment.sourceWarehouse?.state
                  "
                >
                  {{ shipment.sourceWarehouse?.code }}
                </div>
                <i class="fal fa-chevron-double-right"></i>
                <div
                  [matTooltip]="
                    shipment.destinationWarehouse?.addressLine1 +
                    ' ' +
                    shipment.destinationWarehouse?.city +
                    ' ' +
                    shipment.destinationWarehouse?.state
                  "
                >
                  {{ shipment.destinationWarehouse?.code }}
                </div>
              </div>
            </div>
            <div class="shipment-list_item-meta">
              <div class="shipment-list_item-boxing" *ngIf="shipment.boxCount">
                Has Boxes
              </div>
            </div>
          </div>
        </ng-template>
      </div>
    </div>
  </mat-dialog-content>
</app-dialog>
